import { Aspect } from '@teambit/harmony';

export const ReactAspect = Aspect.create({
  id: 'teambit.react/react',
});

export default ReactAspect;
